import { createAction, props } from '@ngrx/store';
import { Contract } from '../shared/models/contract.model';

export const addContract = createAction('[Contracts] Add Contract', props<{ contract: Contract }>());
export const updateContract = createAction('[Contracts] Update Contract', props<{ contract: Contract }>());
export const deleteContract = createAction('[Contracts] Delete Contract', props<{ contractId: string }>());
export const deleteAllContracts = createAction('[Contracts] Delete All Contracts');
